module.exports = __webpack_public_path__ + "static/fonts/Quicksand-Bold.42c6212.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/Quicksand-Bold.woff
// module id = EwDL
// module chunks = 1